<template>
  <SearchModal
    ref="SearchModal"
    class="searchTable"
    :type="searchData.type || 'post'"
    :API="searchData.API"
    :extraData="
      combineExtraData
        ? Object.assign(extraData, searchData.extraData)
        : extraData || searchData.extraData
    "
    :query="searchData.query"
    :searchColumns="searchData.searchColumns"
    :columnList="searchData.columnList"
    :placeholder="placeholder || $t('search.choose')"
    :width="searchData.width || '800'"
    :propCode="searchData.propCode"
    :propName="propName || searchData.propName"
    :expandAll="searchData.expandAll"
    :currentValue="defaultValue"
    :checkRowKeys="checkRowKeys"
    :isMultiple="isMultiple"
    :isReadOnly="isReadOnly"
    :parseExtendMap="parseExtendMap"
    :placement="placement"
    :disabled="disabled"
    :trigger="trigger"
    :initShow="initShow"
    :isFixed="isFixed"
    :disableNoSearchData="searchData.disableNoSearchData"
    :options="searchData.options"
    :label-width="searchData.labelWidth || '90px'"
    @setSearchModal="setSearchModal"
    @setSearchModalInput="setSearchModalInput"
    @changeQuery="changeQuery"
  ></SearchModal>
</template>
<script>
  import BANK_API from '@/api/masterData/bank';
  import SearchModal from './index.vue';
  import { mapState } from 'vuex';

  export default {
    props: {
      searchType: {
        type: String,
        default: '',
      },
      //是否单选
      isMultiple: {
        type: Boolean,
        default: false,
      },
      isReadOnly: {
        type: Boolean,
        default: true,
      },
      currentValue: {
        type: String,
        default: '',
      },
      //默认选中
      checkRowKeys: {
        type: Array,
        default: () => [],
      },
      //额外参数
      extraData: {
        type: Object,
        default: () => {},
      },
      //列信息特殊判断使用
      columnExtra: {
        type: Object,
        default: () => {},
      },
      //默认传的propName
      propName: {
        type: String,
        default: '',
      },
      placement: {
        type: String,
        default: () => 'top',
      },
      //是否禁用
      disabled: {
        type: Boolean,
        default: false,
      },
      placeholder: {
        type: String,
        default: '',
      },
      //是否允许多值输入查询
      isNeedMultipleValue: {
        type: Boolean,
        default: false,
      },
      //解析extendMap
      parseExtendMap: {
        type: Boolean,
        default: false,
      },
      // 点击方式
      trigger: {
        type: String,
        default: 'click',
      },
      // 传入的数据列表
      options: {
        type: Array,
        default: () => [],
      },
      // 是否默认初始化查询
      initShow: {
        type: Boolean,
        default: true,
      },
      combineExtraData: {
        type: Boolean,
        default: false,
      },
      isFixed: {
        type: Boolean,
        default: false,
      },
    },
    components: {
      SearchModal,
    },
    data() {
      return {
        defaultValue: this.currentValue,
        companyCode: null,
        departmentList: [], // 部门
        supplierList: [], //供应链主体
        searchTypeClone: null, //定义在控件内的searchType，用于根据条件切换不同控件
        settlementBusinessType: '01',
        dispatchFlag: 20, //保修单传递参数
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
      // 动态获取当前属于什么搜索
      searchData() {
        const searchType = this.searchTypeClone;
        return this[searchType];
      },
      // 银行
      bank() {
        return {
          query: {
            bankCode: '',
          },
          API: BANK_API.GET_LIST_BANK,
          propName: 'bankName', // 输入框展示内容
          propCode: 'bankCode',
          expandAll: true,
          extraData: {
            bankStatus: '01',
          },
          //   searchColumns: [
          //     {
          //       name: '银行名称',
          //       prop: 'bankName',
          //       type: 'input',
          //     },
          //     {
          //       name: '分行',
          //       prop: 'branchName',
          //       type: 'input',
          //     },
          //     {
          //       name: '银行行号',
          //       prop: 'bankUnionNumber',
          //       type: 'input',
          //     },
          //   ],
          //   columnList: [
          //     {
          //       prop: 'bankCode',
          //       label: this.$t('bank.label.bankCode'),
          //     },
          //     {
          //       prop: 'bankName',
          //       label: '银行名称',
          //     },
          //     {
          //       prop: 'branchName',
          //       label: this.$t('bank.label.branch'),
          //     },
          //     {
          //       prop: 'bankUnionNumber',
          //       label: '银行行号',
          //     },
          //   ],
        };
      },
    },
    watch: {
      currentValue() {
        this.defaultValue = this.currentValue;
      },
      searchType: {
        handler(newV) {
          this.searchTypeClone = newV;
        },
        deep: true,
        immediate: true,
      },
    },
    mounted() {
      this.companyCode = this.userInfo.companyCode;
    },
    methods: {
      changeQuery(newValue) {
        if (this.searchType == 'receivableSettlementForLine') {
          if (newValue.settlementBusinessType == '01') {
            this.searchTypeClone = 'receivableSettlementForLine';
          } else {
            this.searchTypeClone = 'receivableSettlementBySaleInvoice';
          }
        }
      },

      //选值
      setSearchModal(type, row) {
        this.$emit('input', row);
      },
      //可以输入
      setSearchModalInput(type, val) {
        this.$emit('inputReadOnly', val);
      },
      // 重置
      resetClick() {
        this.defaultValue = this.currentValue;
        if (this.$refs.SearchModal) {
          this.$refs.SearchModal.resetClick();
        }
      },
      //关闭弹窗
      blurModal() {
        this.$refs.SearchModal.blurModal();
      },
    },
  };
</script>
